import React, { useCallback } from 'react';

import { useRouter } from 'next/router';

import { Box, Button } from '@explorer/core';
import { useParam } from '@explorer/hooks';
import { appRoutes } from '@explorer/src';
import PublishIcon from '@mui/icons-material/Publish';
import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';

export const ModifyAccount = (props: { clientId?: string }) => {
  const intl = useIntl();
  const theme = useTheme();
  const router = useRouter();
  const clientIdFromParam = useParam('cid');

  const { clientId } = props;
  const clientIdToUse = clientId || clientIdFromParam;

  const modifyAccount = useCallback(() => {
    const w = window.btoa(
      JSON.stringify({
        client_id: clientIdToUse || '',
      }),
    );
    router.push({
      pathname: appRoutes['/admin-control/modify-client'],
      query: {
        w,
      },
    });
  }, [clientIdToUse, router]);

  return (
    <Box textAlign="right" pb={1}>
      <Button
        width={160}
        color="secondary"
        bgColor={theme.palette.primary.dark}
        onClick={modifyAccount}
        startIcon={<PublishIcon />}
      >
        {intl.formatMessage({
          id: 'admin.modify-client',
        })}
      </Button>
    </Box>
  );
};
